import http from "../http";
import api from "../../config/api";
import {
  LandDetailResponse,
  LandsListResponse,
} from "../../interfaces/api/lands";

export interface LandsFilterParams {
  page?: number;
}

/**
 * Service for fetching lands data from the API
 */
const lands = {
  /**
   * Fetches lands list from the API with pagination
   * @param {LandsFilterParams} params - Filter parameters including page
   * @returns {Promise<LandsListResponse>} A Promise that resolves to the lands list response
   */
  getLands: (
    params: LandsFilterParams = { page: 1 },
  ): Promise<LandsListResponse> =>
    new Promise((resolve, reject) => {
      const { page = 1 } = params;
      const url = `${api.lands.list}?page=${page}&page_size=20`;

      http
        .get(url)
        .then((res) => resolve(res as LandsListResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Fetches land details from the API
   * @param {number} id - The ID of the land to fetch
   * @returns {Promise<LandDetailResponse>} A Promise that resolves to the land detail response
   */
  getLandDetail: (id: number): Promise<LandDetailResponse> =>
    new Promise((resolve, reject) => {
      http
        .get(api.lands.detail(id))
        .then((res) => resolve(res as LandDetailResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Fetches featured lands from the API
   * @returns {Promise<LandsListResponse>} A Promise that resolves to the featured lands response
   */
  getFeaturedLands: (): Promise<LandsListResponse> =>
    new Promise((resolve, reject) => {
      http
        .get(api.lands.featured)
        .then((res) => resolve(res as LandsListResponse))
        .catch((e) => reject(e));
    }),
};

export default lands;
